
import { UserPlus } from "lucide-react";
import { ButtonColorful } from "@/components/ui/button-colorful";

interface ClientEmptyStateProps {
  onAddClient: () => void;
}

export function ClientEmptyState({ onAddClient }: ClientEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center space-y-4">
      <div className="bg-white/10 p-4 rounded-full">
        <UserPlus className="h-8 w-8 text-white" />
      </div>
      <h3 className="text-xl font-semibold text-white">No clients yet</h3>
      <p className="text-white/70 max-w-sm">
        Start growing your coaching business by adding your first client
      </p>
      <ButtonColorful 
        label="Add Your First Client"
        className="mt-4"
        onClick={onAddClient}
      />
    </div>
  );
}
